import FixedBar from './src/main'

FixedBar.install = function (Vue) {
  Vue.component(FixedBar.name, FixedBar)
}

export default FixedBar
